import React from "react";
import firebase from "firebase";
import axios from "axios";
import {storage} from "../firebase";

//use in statistics for how many users logged in today
export function UpdateUserCount() {
    firebase.auth().onAuthStateChanged((user) => {
        if (user) {
            const dateArray = new Date().toString().split(' ');
            const todaysDate = dateArray[1] + "/" + dateArray[2] + "/" + dateArray[3];
            let userName = user.email.split('@')[0];
            let newEntry = {date: todaysDate, viewCount: 1, user: [userName]};

            if(userName === 'uhadmin'){
                return;
            }
            let studentData;
            let userFound = false;
            let dateFound = false;

            //Fetching student file data
            const studentFile = firebase.storage().ref().child('students/studentViews.json');
            studentFile.getDownloadURL()
                .then(url => axios.get(url))
                .then(res => {

                    studentData = res.data;

                    //Keeps data length max at 10
                    if(studentData.length > 10){
                        studentData.splice(0,1)
                    }

                    //Search the data if it is the same user logging in, if not, increment view count
                    for(let i = 0; i < studentData.length; i++) {
                        if(todaysDate === studentData[i].date){
                            dateFound = true;
                            for(let w = 0; w < studentData[i].user.length; w++){
                                if(userName === studentData[i].user[w]){
                                    userFound = true;
                                }
                            }
                            if(!userFound){
                                studentData[i].viewCount += 1;
                                studentData[i].user.push(userName)
                            }
                            break;
                        }
                    }

                    //if entry not found for today, create the new entry
                    if(!dateFound) {
                        studentData.push(newEntry)
                    }

                    //turn into json and upload to Firebase
                    const JSONobj = JSON.stringify(studentData);
                    const blobObj = new Blob([JSONobj], {type: "application/json"});
                    const uploadTask = storage.ref('students/studentViews.json').put(blobObj);
                    uploadTask.on(
                        "state_changed",
                        () => {
                        },
                        error => {
                            console.log(error)
                        },
                        () => {
                            storage
                                .ref("students")
                                .child('studentViews.json')
                                .getDownloadURL()
                                .then(url => {
                                        console.log(url);
                                    }
                                )
                                .catch(e => console.log(e));
                        }
                    )
                });


        }
    })
}
